/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/agenda")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsByArtisan({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/agendaByArtisan")
        .then((response) => {
          commit('SET_ITEMS_BY_ARTISAN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/agenda/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM', response.data[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
  
}
